import React from "react";

import { BusinessService } from "0.Mine/3.Interfaces/Services";
import { SafeArgonSnackbar } from "0.Mine/4.Argon/ArgonComponents";
import ArgonSnackbar from "components/ArgonSnackbar";

import { BusinessFormProps } from "../Logic/BusinessFormProps";
import { useServiceManagerLogic } from "../Logic/ServiceManager";
import ServicesFormUI from "../UI/BusinessServiceManager";

const ServiceManager: React.FC<BusinessFormProps> = ({ business }) => {
  const {
    session,
    treatments,
    handleAddTreatment,
    handleDeleteTreatment,
    handleReorderTreatments,
    handleUpdateTreatment,
    closeSnackBar,
    openSnackBar,
    snackBarMessage,
  } = useServiceManagerLogic(business);

  // Ensure a business session is selected.
  if (!session || !session.selectedBusiness) {
    return <p>Select a business</p>;
  }

  return (
    <>
      <ServicesFormUI
        businessid={session.selectedBusiness.id}
        treatments={treatments}
        onAdd={handleAddTreatment}
        onDelete={handleDeleteTreatment}
        onReorder={handleReorderTreatments}
        onUpdate={handleUpdateTreatment} // Add this prop
      />
      <ArgonSnackbar
        bgWhite={true}
        color="error"
        icon="error"
        title="Error"
        content={snackBarMessage}
        dateTime={new Date().toLocaleDateString()}
        open={openSnackBar}
        close={closeSnackBar}
      />
    </>
  );
};

export default ServiceManager;
